import { Colors } from '@oy/uicore';
import { FieldContainer, Text, toast } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import { toUpper } from 'lodash-es';
import { useRef } from 'react';
import { StatusPillV2 } from 'src/components';
import useTranslate from 'src/hooks/useTranslate';
import { ManualTopupState } from 'src/redux/reducers/manualTopupReducer';
import { formatCurrency } from 'src/utilities/helpers';
import styles from './ManualTopupTransactionModal.module.css';

export const TopupInfo = (props: ManualTopupState) => {
  const { getTranslation } = useTranslate();
  const inputRef = useRef<HTMLInputElement>(null);

  const copyUrl = () => {
    const ref = inputRef.current;
    if (ref) {
      ref.select();
      ref.setSelectionRange(0, 999999);

      const successful = document.execCommand('copy');
      if (successful) {
        toast.success(getTranslation('common_urlCopied'));
      } else {
        toast.error(getTranslation('error_failedCopyURL'));
      }
    }
  };

  const topupData = [
    {
      label: getTranslation(
        'manualTopUpFormTransactionModal_text_topUpTransID',
      ),
      value: (
        <Text color={Colors.BLACK80} textStyle={Text.Style.HeadingXs}>
          {props.requestId}
          <SystemIcon
            name="copy"
            color={Colors.BLACK100}
            className={styles.copyButton}
            onClick={copyUrl}
          />
        </Text>
      ),
    },
    {
      label: getTranslation('topup_manualTopup_submitTime'),
      value: (
        <Text color={Colors.BLACK80} textStyle={Text.Style.HeadingXs}>
          {props.submitTime}
        </Text>
      ),
    },
    {
      label: getTranslation('common_status'),
      value: <StatusPillV2 status="WAITING" />,
    },
    {
      label: getTranslation('common_amount'),
      value: (
        <Text color={Colors.BLACK80} textStyle={Text.Style.HeadingXs}>
          {formatCurrency(props.amount)}
        </Text>
      ),
    },
    {
      label: getTranslation('manualTopUpForm_select_label_beneficiaryBank'),
      value: (
        <Text color={Colors.BLACK80} textStyle={Text.Style.HeadingXs}>
          {props.oy_payment_code}
        </Text>
      ),
    },
    {
      label: getTranslation(
        'manualTopUpForm_radio_title_transferReceiptRefNum',
      ),
      value: (
        <Text color={Colors.BLACK80} textStyle={Text.Style.HeadingXs}>
          {props.ref_number}
        </Text>
      ),
    },
  ];

  return (
    <>
      <input
        className={styles.hiddenInput}
        value={props.requestId || ''}
        readOnly
        ref={inputRef}
      />
      {topupData.map(info => (
        <FieldContainer label={toUpper(info.label)}>
          {info.value}
        </FieldContainer>
      ))}
    </>
  );
};
